var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_vm._v("网络错误，请重新刷新本页！")])
}
var staticRenderFns = []

export { render, staticRenderFns }